module.exports = __webpack_public_path__ + "img/cert30.2372600d.png";